import React, { useState } from "react";
import SummaryApi from "../common";
import Swal from "sweetalert2"; // npm install sweetalert2
import bgimage from "../assest/sgu.webp";
import topLeftImage from "../assest/sgu_name.png";
import topRightImage from "../assest/OAKYA.png";
const qualifications = ["MPC", "BiPC"];

const mpcCourses = [
  "CSE",
  "IT",
  "AI & ML",
  "Data Science",
  "ECE",
  "Cyber Security",
  "EEE",
  "Mech",
];

const bipcCourses = ["Pharmacy", "MBBS", "BDS", "Nursing", "Physiotherapy"];

const OakyaStudentForm = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    parent_name: "",
    mobile_number: "",
    alternate_mobile_number: "",
    email: "",
    qualification: "",
    intrested_course: [],
    city: "",
    address: "",
    clg_name: "SGU",
  });

  const [formErrors, setFormErrors] = useState({});

  // Fake existing mobile numbers for uniqueness check (replace with actual API check)
  const existingMobileNumbers = ["9876543210", "9123456789"];

  // Get courses based on selected qualification
  const getCoursesByQualification = () => {
    if (formData.qualification === "MPC") {
      return mpcCourses;
    } else if (formData.qualification === "BiPC") {
      return bipcCourses;
    } else {
      return [];
    }
  };

  const coursesToShow = getCoursesByQualification();

  // Validate function
  const validate = () => {
    const errors = {};

    if (!formData.full_name.trim()) {
      errors.full_name = "Full name is required";
    }

    if (!formData.parent_name.trim()) {
      errors.parent_name = "Parent name is required";
    }

    if (!formData.mobile_number.trim()) {
      errors.mobile_number = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      errors.mobile_number = "Mobile number must be exactly 10 digits";
    } else if (existingMobileNumbers.includes(formData.mobile_number)) {
      errors.mobile_number = "Mobile number already exists";
    }

    if (!formData.qualification) {
      errors.qualification = "Qualification is required";
    }

    if (formData.intrested_course.length === 0) {
      errors.intrested_course = "At least one course must be selected";
    }

    setFormErrors(errors);

    // If no errors, return true
    return Object.keys(errors).length === 0;
  };

  // Handle change for all inputs except the multi-select course dropdown
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "qualification") {
      setFormData((prev) => ({
        ...prev,
        qualification: value,
        intrested_course: [], // clear courses when qualification changes
      }));
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        qualification: undefined,
        intrested_course: undefined,
      }));
      return;
    }

    if (name === "intrested_course") {
      if (value && !formData.intrested_course.includes(value)) {
        setFormData((prev) => ({
          ...prev,
          intrested_course: [...prev.intrested_course, value],
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for the field on change
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };

  // Remove a selected course when user clicks on it
  const removeCourse = (courseToRemove) => {
    setFormData((prev) => ({
      ...prev,
      intrested_course: prev.intrested_course.filter(
        (course) => course !== courseToRemove
      ),
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      intrested_course: undefined,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fix the form errors.",
        timer: 1000,
        showConfirmButton: true,
        timerProgressBar: true,
        allowOutsideClick: false,
      });

      return;
    }

    try {
      const response = await fetch(SummaryApi.createStudent.url, {
        method: SummaryApi.createStudent.method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json(); // 👈 parse the actual API response body

      if (response.ok && result.status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: result.message || "Student created successfully!",
          timer: 1000,
          showConfirmButton: true,
          timerProgressBar: true,
          allowOutsideClick: false,
        });

        // Reset form
        setFormData({
          full_name: "",
          parent_name: "",
          mobile_number: "",
          alternate_mobile_number: "",
          email: "",
          qualification: "",
          intrested_course: [],
          city: "",
          address: "",
          clg_name: "SGU",
        });
        setFormErrors({});
      } else {
        // API returned status: false or bad HTTP response
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: result.message || "Failed to create student.",
          timer: 1000,
          showConfirmButton: true,
          timerProgressBar: true,
          allowOutsideClick: false,
        });

        // Optionally: if the error is specific (e.g. mobile exists), you can highlight it
        if (result.message?.toLowerCase().includes("mobile")) {
          setFormErrors((prev) => ({
            ...prev,
            mobile_number: result.message,
          }));
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgimage})`,
        backgroundSize: "cover",
        // backgroundPosition: 'center',
        backgroundRepeat: "no-repeat",
      }}
      className="w-full min-h-screen"
    >
      
        <div className="flex items-center">
          <img src={topLeftImage} alt="Logo 1" className="w-[70%] mx-auto" />
        </div>

 

      <div className="w-[90%] md:w- p-6 bg-white rounded-[10px] shadow-md mt-[10px]  mx-auto mb-[10%] ">
        <h2 className="text-2xl font-bold mb-6 text-center">
          Student Enrollment
        </h2>
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {/* Full Name */}
          <div>
            <label
              htmlFor="full_name"
              className="block text-sm font-medium text-gray-700"
            >
              Full Name *
            </label>
            <input
              type="text"
              name="full_name"
              id="full_name"
              value={formData.full_name}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border px-4 py-1 ${
                formErrors.full_name ? "border-red-500" : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
            />
            {formErrors.full_name && (
              <p className="text-red-600 text-sm mt-1">
                {formErrors.full_name}
              </p>
            )}
          </div>

          {/* Parent Name */}
          <div>
            <label
              htmlFor="parent_name"
              className="block text-sm font-medium text-gray-700 "
            >
              Parent/Guardian Name *
            </label>
            <input
              type="text"
              name="parent_name"
              id="parent_name"
              value={formData.parent_name}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border px-4 py-1 ${
                formErrors.parent_name ? "border-red-500" : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
            />
            {formErrors.parent_name && (
              <p className="text-red-600 text-sm mt-1">
                {formErrors.parent_name}
              </p>
            )}
          </div>

          {/* Mobile Number */}
          <div>
            <label
              htmlFor="mobile_number"
              className="block text-sm font-medium text-gray-700"
            >
              Mobile Number *
            </label>
            <input
              type="tel"
              name="mobile_number"
              id="mobile_number"
              value={formData.mobile_number}
              onChange={handleChange}
              maxLength={10}
              pattern="\d{10}"
              className={`mt-1 block w-full rounded-md border px-4 py-1 ${
                formErrors.mobile_number ? "border-red-500" : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
            />
            {formErrors.mobile_number && (
              <p className="text-red-600 text-sm mt-1">
                {formErrors.mobile_number}
              </p>
            )}
          </div>

          {/* Alternate Mobile Number */}
          <div>
            <label
              htmlFor="alternate_mobile_number"
              className="block text-sm font-medium text-gray-700"
            >
              Alternate Mobile Number
            </label>
            <input
              type="tel"
              name="alternate_mobile_number"
              id="alternate_mobile_number"
              value={formData.alternate_mobile_number}
              onChange={handleChange}
              maxLength={10}
              pattern="\d{10}"
              className={`mt-1 block w-full rounded-md border px-4 py-1 ${
                formErrors.alternate_mobile_number
                  ? "border-red-500"
                  : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
            />
            {formErrors.alternate_mobile_number && (
              <p className="text-red-600 text-sm mt-1">
                {formErrors.alternate_mobile_number}
              </p>
            )}
          </div>

          {/* Email */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              Email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border px-4 py-1 ${
                formErrors.email ? "border-red-500" : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
            />
            {formErrors.email && (
              <p className="text-red-600 text-sm mt-1">{formErrors.email}</p>
            )}
          </div>

          {/* Qualification */}
          <div>
            <label
              htmlFor="qualification"
              className="block text-sm font-medium text-gray-700"
            >
              Qualification *
            </label>
            <select
              name="qualification"
              id="qualification"
              value={formData.qualification}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border px-4 py-1 ${
                formErrors.qualification ? "border-red-500" : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
            >
              <option value="" disabled>
                Select Inter Group
              </option>
              {qualifications.map((q) => (
                <option key={q} value={q}>
                  {q}
                </option>
              ))}
            </select>
            {formErrors.qualification && (
              <p className="text-red-600 text-sm mt-1">
                {formErrors.qualification}
              </p>
            )}
          </div>

          {/* Interested Course(s) */}
          <div className="md:col-span-2">
            <label
              htmlFor="intrested_course"
              className="block text-sm font-medium text-gray-700"
            >
              Intrested Course(s) *
            </label>
            <select
              name="intrested_course"
              id="intrested_course"
              value=""
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border px-4 py-1 ${
                formErrors.intrested_course
                  ? "border-red-500"
                  : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
              disabled={!formData.qualification}
            >
              <option value="" disabled>
                {formData.qualification === "MPC"
                  ? "Select B.Tech"
                  : formData.qualification === "BiPC"
                  ? "Select Medical Courses"
                  : "Select Course"}
              </option>
              {coursesToShow
                .filter((course) => !formData.intrested_course.includes(course))
                .map((course) => (
                  <option key={course} value={course}>
                    {course}
                  </option>
                ))}
            </select>
            {formErrors.intrested_course && (
              <p className="text-red-600 text-sm mt-1">
                {formErrors.intrested_course}
              </p>
            )}

            {/* Display selected courses */}
            <div className="mt-2 flex flex-wrap gap-2">
              {formData.intrested_course.map((course) => (
                <span
                  key={course}
                  className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-100 text-indigo-700 cursor-pointer"
                  onClick={() => removeCourse(course)}
                  title="Click to remove"
                >
                  {course}{" "}
                  <svg
                    className="ml-1 w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </span>
              ))}
            </div>
          </div>

          {/* City */}
          <div>
            <label
              htmlFor="city"
              className="block text-sm font-medium text-gray-700"
            >
              City/ Village/Town
            </label>
            <input
              type="text"
              name="city"
              id="city"
              value={formData.city}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border px-4 py-1 ${
                formErrors.city ? "border-red-500" : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
            />
            {formErrors.city && (
              <p className="text-red-600 text-sm mt-1">{formErrors.city}</p>
            )}
          </div>

          {/* Address */}
          <div className="md:col-span-2">
            <label
              htmlFor="address"
              className="block text-sm font-medium text-gray-700"
            >
              Address
            </label>
            <textarea
              name="address"
              id="address"
              value={formData.address}
              onChange={handleChange}
              rows={3}
              className={`mt-1 block w-full rounded-md border ${
                formErrors.address ? "border-red-500" : "border-gray-300"
              } shadow-sm focus:border-indigo-500 focus:ring-indigo-500`}
            />
            {formErrors.address && (
              <p className="text-red-600 text-sm mt-1">{formErrors.address}</p>
            )}
          </div>

          {/* Submit Button */}
          <div className="md:col-span-2">
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition"
            >
              Submit
            </button>
          </div>
        </form>
        {/* <p className="text-center mt-4 text-sm text-gray-500">
        Powered by{" "}
        <a
          href="https://oakyaitservices.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-600 hover:underline"
        >
          Oakya IT Services Pvt Ltd
        </a>
      </p> */}
      </div>
    </div>
  );
};

export default OakyaStudentForm;
